var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBtn2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 279,
  height: 75,
  fill: "none",
  viewBox: "0 0 279 75"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M276.932 2.238H2.534v70.524h274.398z",
  opacity: 0.9
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M2.534 72.762H278V68.95H2.534z",
  opacity: 0.3,
  style: {
    mixBlendMode: "screen"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "M276.932 72.762V2h-3.737v70.762z",
  opacity: 0.3,
  style: {
    mixBlendMode: "screen"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#c)",
  stroke: "url(#d)",
  strokeMiterlimit: 10,
  d: "M2.534 2v70.762h5.872V2z",
  opacity: 0.3,
  style: {
    mixBlendMode: "screen"
  }
}), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#e)",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  d: "M29.226 73H2V59.896"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#f)",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  d: "M250.24 72.643h27.227V59.539"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#g)",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  d: "M256.112 2h21.354v14.534"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#h)",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  d: "M2 12.84V2.12h35.768"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 140.267,
  x2: 140.267,
  y1: 72.762,
  y2: 68.951,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00A32E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#384B42"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#030505",
  stopOpacity: 0.07
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 276.932,
  x2: 273.195,
  y1: 37.381,
  y2: 37.381,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00A32E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#384B42"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#030505",
  stopOpacity: 0.07
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 2.534,
  x2: 8.406,
  y1: 37.381,
  y2: 37.381,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00A32E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#384B42"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#030505",
  stopOpacity: 0.07
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 2.428,
  x2: 8.512,
  y1: 37.381,
  y2: 37.381,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00A32E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#384B42"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#030505",
  stopOpacity: 0.07
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: 1.542,
  x2: 29.226,
  y1: 66.565,
  y2: 66.565,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#26F028"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#011F21"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: 277.925,
  x2: 250.24,
  y1: 66.208,
  y2: 66.208,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#26F028"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#011F21"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: 277.871,
  x2: 256.112,
  y1: 8.526,
  y2: 8.526,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#26F028"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#011F21"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "h",
  x1: 19.565,
  x2: 19.565,
  y1: 1.939,
  y2: 12.841,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#26F028"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#011F21"
})))));
export { SvgBtn2 as ReactComponent };
export default "data:image/svg+xml;base64,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";